import React from 'react';
import "./onboard-loading-style.scss";
import {useRecoilValue} from "recoil";
import {loadingAtom} from "../../../store/LoadingStore";
import logo from './images/loading.gif';

const OnboardLoading = () => {

    const loading = useRecoilValue(loadingAtom);

    return (
        loading && (<div>
            <div className="onboard-loading-opacity"></div>
            <div className="onboard-loading-root">
                <div className="onboard-loading-load onboard-loading">
                    <img src={logo} alt="loading..."/>
                </div>
            </div>
        </div>)
    )
};

export default OnboardLoading;
